import { useEffect } from 'react';

/**
 * Locks background scroll while a modal / bottom-sheet is open.
 * Ref-counted so nested overlays don't unlock the page early.
 * Pass the "is this overlay currently shown" flag; defaults to true
 * for components that are only mounted while visible.
 */
let lockCount = 0;
let savedOverflow = '';
let savedPaddingRight = '';

export default function useScrollLock(active = true) {
  useEffect(() => {
    if (!active || typeof document === 'undefined') return undefined;

    if (lockCount === 0) {
      const { body } = document;
      const scrollbarW = window.innerWidth - document.documentElement.clientWidth;
      savedOverflow = body.style.overflow;
      savedPaddingRight = body.style.paddingRight;
      body.style.overflow = 'hidden';
      if (scrollbarW > 0) body.style.paddingRight = `${scrollbarW}px`;
    }
    lockCount += 1;

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) {
        const { body } = document;
        body.style.overflow = savedOverflow;
        body.style.paddingRight = savedPaddingRight;
      }
    };
  }, [active]);
}
